import {throttle} from '../../../app/utils'

require('./glow.sass')

export class Glow {
  syncPointer = ({ x, y }) => {
    document.documentElement.style.setProperty('--x', x.toFixed(2))
    document.documentElement.style.setProperty(
      '--xp',
      (x / window.innerWidth).toFixed(2)
    )
    document.documentElement.style.setProperty('--y', y.toFixed(2))
    document.documentElement.style.setProperty(
      '--yp',
      (y / window.innerHeight).toFixed(2)
    )
  }

  syncLocalPointer = () => {

    const wrapper = document.body;

    wrapper.addEventListener("mousemove", throttle(function ($event) {
      const cards = document.querySelectorAll(".hey");

      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const x = $event.clientX - rect.left
        const y = $event.clientY - rect.top

        card.style.setProperty("--x", x.toFixed(2))
        card.style.setProperty("--y", y.toFixed(2))
      })
    }, 42))
  }


  constructor() {
    let syncPointer = this.syncPointer

    this.syncLocalPointer()

    document.body.addEventListener('pointermove', throttle(syncPointer, 42))
  }


}